<template>
<div class="csv-parser">
  <h2>CSV Parser</h2>

  <p>Select a CSV file with columns containing <em>timestamp</em>, <em>name</em> and <em>cost</em> data (in that order).</p>
  <p>Same name rows will be bunched together into the same bar.</p>
  <p>First row will be ignored.</p>

  <input type="file" v-on:change="processFile">

  <div class="chart-wrapper">
    <BarChart class="chart" v-bind:chartData="chartData" v-bind:options="options" ref="barChart" />
  </div>

</div>
</template>

<script>
import BarChart from '@/components/BarChart.vue'

export default {
  name: 'file-reader',
  components: {
    BarChart
  },
  data: function() {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false
            }
          }]
        }
      }
    }
  },
  methods: {
    processFile: function(e) {
      let self = this;
      var reader = new FileReader();
      reader.onload = function(e) {
        var lines = e.target.result.split(/\r?\n/g)
        var transactionMap = new Map()
        lines.shift()
        for (let line of lines) {
          var cells = line.split(",")
          if (cells[0] && cells[1] && cells[2]) {
            if(cells[1].match(/[\uFFFD]/g)) {
              alert('Your CSV file must be properly UTF-8 encoded')
              self.chartData.labels = []
              self.chartData.datasets = []
              self.$refs.barChart.update()
              return
            }
            if (transactionMap.get(cells[1]) == undefined) {
              transactionMap.set(cells[1], cells[2])
            } else {
              transactionMap.set(cells[1], parseInt(transactionMap.get(cells[1])) + parseInt(cells[2]))
            }
          }
        }
        self.chartData.labels = []
        self.chartData.datasets = []

        var costs = []
        for (var [name, cost] of transactionMap) {
          self.chartData.labels.push(name)
          costs.push(cost)
        }

        self.chartData.datasets.push({
          label: e.target.fileName,
          fill: false,
          backgroundColor: '#31F236',
          borderColor: '#31F236',
          data: costs
        })

        self.$refs.barChart.update()
      }
      reader.fileName = e.target.files[0].name;
      reader.readAsText(e.target.files[0], 'UTF-8');
    },

  }
}
</script>

<style scoped>
h2 {
  padding-top: 20px;
  font-weight: normal;
}

.chart-wrapper {
  position: relative;
  height: 75vh;
}

.csv-parser {
  margin: auto;
  width: 75%;
  overflow: auto;
}

.chart {
  width: 100%;
  height: 80%;
  margin: auto;
  overflow: auto;
}
</style>
